import { $http } from '@tajawal/web-core-sdk-v2/lib/services/http.service';
import { replaceParams } from "../utils/client.utils/index.js";
import { ENDPOINTS } from "../constants/index.js";
export var SaleClient = {
  getCart: function getCart(_ref) {
    var saleId = _ref.saleId,
      timeout = _ref.timeout;
    var requestId = "GET_SALE";
    var endPoint = replaceParams(ENDPOINTS.SALE.GET_SALE, {
      saleId: saleId
    });
    return $http.get(requestId, endPoint, {
      timeout: timeout
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  },
  getSaleByNumber: function getSaleByNumber(_ref3) {
    var id = _ref3.id,
      number = _ref3.number;
    var requestId = "GET_SALE_BY_NUMBER";
    var endPoint = replaceParams(ENDPOINTS.SALE.GET_SALE_BY_NUMBER, {
      number: number,
      id: id
    });
    return $http.get(requestId, endPoint).then(function (_ref4) {
      var data = _ref4.data;
      return data;
    });
  },
  calculateRewards: function calculateRewards(_ref5) {
    var saleId = _ref5.saleId;
    var requestId = "CALCULATE_REWARD";
    var endPoint = replaceParams(ENDPOINTS.SALE.CALCULATE_REWARD, {
      saleId: saleId
    });
    return $http.post(requestId, endPoint).then(function (_ref6) {
      var data = _ref6.data;
      return data;
    });
  }
};